export default {
      id: "circle__coords-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__coords",
      toString: function () {
        return this.url;
      }
    }